import { getCookie } from '@api/HelperAPI';
import { useGetContext } from '@api/lendingAPI/lapiHooks';

export const useOffersPageVersion = (): '2.1' | '2.0' | '1.0' => {
    const { data } = useGetContext();

    // TODO k.anyabuike: Replace this with the offers_page_longer_durations_q2_2026 split test
    if (getCookie('newOffersPage2_1') === 'True') {
        return '2.1';
    }

    if (
        data?.user_split_tests.some(
            (key) =>
                'new_offers_page_q1_2026' in key &&
                Boolean(key.new_offers_page_q1_2026)
        )
    ) {
        return '2.0';
    }

    return '1.0';
};
